/*eslint no-unused-vars: "off"*/
import { getPageAnalytics, getCartAnalytics } from '@ynap/analytics';

export default function createAnalyticsEvent(props) {
    const { lineItems, userStatus, orderRef, analytics, locale, pageAnalyticsStep, x_exchangeRate } = props;
    if (lineItems.length < 1) return {};

    const statusTypes = {
        R: 'existing',
        G: 'guest',
        N: 'new',
    };
    const cart = getCartAnalytics(props);
    const { cartID, ...rest } = cart;
    const numSaleItems = lineItems.filter((each) => each.onSale);
    const attributes = {
        orderType: statusTypes[userStatus],
        saleOrderFlag: numSaleItems === lineItems.length ? 'sale order' : numSaleItems > 0 ? 'partial sale order' : 'not sale order',
    };
    const exchangeAttribute = x_exchangeRate
        ? {
              extraAttributes: {
                  exchangeRateGBP: x_exchangeRate?.exchangeRateGBP || '1',
                  exchangeRateEUR: x_exchangeRate?.exchangeRateEUR || '1',
                  exchangeRateGBPDaily: x_exchangeRate?.exchangeRateGBPDaily || '1',
                  exchangeRateEURDaily: x_exchangeRate?.exchangeRateEURDaily || '1',
              },
          }
        : {};
    const pageAnalytics = getPageAnalytics({
        ...analytics,
        ...locale,
        pageName: `checkout - ${pageAnalyticsStep}`,
        ...exchangeAttribute,
    });
    const { page } = pageAnalytics;

    // override page.category, adding extra properties.
    page.category = {
        pageType: 'checkout',
        primaryCategory: 'purchase',
        subCategory1: 'checkout',
        subCategory2: pageAnalyticsStep,
    };

    return {
        ...pageAnalytics,
        page,
        transaction: {
            transactionID: orderRef,
            ...rest,
            attributes,
        },
        cart,
    };
}
